module.exports = __webpack_public_path__ + "static/todo-fd667003329901a854883a1dd692a359.jpg";